export const OFFER_GROUP_MODEL = "offer-group";
import { OFFER_GROUP_DOCUMENTS } from "@/models/relationships";

const offerGroupModel = {
  displayOrder: 0,
  name: "",
  documents: {
    jsonApi: "hasMany",
    type: OFFER_GROUP_DOCUMENTS
  },
  offer: {
    jsonApi: "hasOne",
    type: "offers"
  }
};

export default offerGroupModel;
